export default __webpack_public_path__ + "static/media/goshen8.072c1963.jpg";